import { FancyButton } from '../../../components/primitives/FancyButton';
import { TpOrganizationInfo } from '../../../api/models/admin';
import { AdminApi } from '../../../api/models/m2mApi';
import { promptCleanUpOrganization } from '../actions/m2mCrudOrganization';
import { useAppDispatch, useUser } from '../../../app/hooks';
import { addPollingConfiguration, PollingConfiguration } from '../../../data/pollingSlice';
import { addNewTaskExecution } from '../../../data/taskExecutionSlice';
import { promptConfirmationBox, TpConfirmData } from '../../../components/message-boxes/ConfirmBox';
import { taskExecutionPollingId } from '../../../data/pollingService';
import { useNavigate } from 'react-router-dom';

interface TpCleanupButtonProps {
  organization: TpOrganizationInfo;
  adminApi: AdminApi;
}

const CleanupButton = ({ organization, adminApi }: TpCleanupButtonProps) => {
  const dispatch = useAppDispatch();
  const { user } = useUser();
  const navigate = useNavigate();

  const handleCleanupAction = () => {
    adminApi
      .getOrganizationIngestionTags(organization.identifier!)
      .then((tags) => {
        return promptCleanUpOrganization(adminApi, organization, user, tags);
      })
      .then((taskExecution) => {
        const confirmData: TpConfirmData = {
          title: `Your Data Cleanup has just started`,
          description: `Would you like to proceed to the 'Task Executions' page? \n\n`,
          cancelButtonLabel: `Close`,
        };
        if (taskExecution) {
          const pollingConfig: PollingConfiguration = {
            identifier: taskExecutionPollingId,
            interval: 15000,
          };
          dispatch(addNewTaskExecution({ taskExecution }));
          dispatch(addPollingConfiguration(pollingConfig));
        }

        return promptConfirmationBox(confirmData).then((confirmed) => {
          if (confirmed) {
            navigate(`/task-executions`);
          }
        });
      });
  };

  return (
    <FancyButton iconName="fas:broom" onClick={handleCleanupAction}>
      Cleanup
    </FancyButton>
  );
};

export default CleanupButton;
